export const isNonNullable = (maybe) => maybe !== null && maybe !== undefined;
//# sourceMappingURL=Nullable.js.map